/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  RDSAlertsStatusInput,
  RDSAlertsStatusType,
} from '..';
import {
  serializeRDSAlertsStatusInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetRDSAlertsStatusInput {
  input?: RDSAlertsStatusInput;
}
const build = (_query: DocumentNode, input: GetRDSAlertsStatusInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.input !== undefined ? `$input: RDSAlertsStatusInput = ${serializeRDSAlertsStatusInput(input.input)}` : '' ) + `){
    getRDSAlertsStatus(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...rdsalertsstatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetRDSAlertsStatusQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment rdsalertsstatustype on RDSAlertsStatusType { ... }
   */
  async execute(_query: DocumentNode, input: GetRDSAlertsStatusInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getRDSAlertsStatus: Partial<RDSAlertsStatusType> }>({ query: build(_query, input), fetchPolicy });
  }
}
